<template>
  <div class="informasi_pendaftaran_berbayar">
    <SOSlotBase
      :container-name="`informasi_pendaftaran_succses`"
      :loading="isLoading"
    >
      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Informasi Pembayaran'"
          :type="'back'"
          @back="back"
        />
      </template>

      <template v-slot:loading-page>
        <SOLoadingPage />
      </template>
      <template v-slot:content>
        <div class="logo_checklist">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 36 36"
            fill="none"
          >
            <path
              d="M18 0.5C22.6413 0.5 27.0925 2.34374 30.3744 5.62563C33.6563 8.90752 35.5 13.3587 35.5 18C35.5 22.6413 33.6563 27.0925 30.3744 30.3744C27.0925 33.6563 22.6413 35.5 18 35.5C13.3587 35.5 8.90752 33.6563 5.62563 30.3744C2.34374 27.0925 0.5 22.6413 0.5 18C0.5 13.3587 2.34374 8.90752 5.62563 5.62563C8.90752 2.34374 13.3587 0.5 18 0.5ZM15.82 21.4525L11.9325 17.5625C11.7931 17.4231 11.6277 17.3126 11.4456 17.2372C11.2635 17.1617 11.0683 17.1229 10.8713 17.1229C10.6742 17.1229 10.479 17.1617 10.2969 17.2372C10.1148 17.3126 9.94937 17.4231 9.81 17.5625C9.52854 17.844 9.37042 18.2257 9.37042 18.6238C9.37042 19.0218 9.52854 19.4035 9.81 19.685L14.76 24.635C14.899 24.7751 15.0643 24.8862 15.2464 24.9621C15.4286 25.038 15.6239 25.077 15.8212 25.077C16.0186 25.077 16.2139 25.038 16.3961 24.9621C16.5782 24.8862 16.7435 24.7751 16.8825 24.635L27.1325 14.3825C27.2737 14.2437 27.3861 14.0783 27.4631 13.8959C27.5401 13.7135 27.5802 13.5176 27.5811 13.3196C27.582 13.1216 27.5437 12.9254 27.4684 12.7422C27.3931 12.5591 27.2823 12.3927 27.1424 12.2526C27.0025 12.1125 26.8362 12.0015 26.6531 11.926C26.4701 11.8505 26.2739 11.812 26.0759 11.8126C25.8779 11.8133 25.682 11.8532 25.4995 11.93C25.317 12.0068 25.1515 12.1189 25.0125 12.26L15.82 21.4525Z"
              fill="#1BB546"
            />
          </svg>
        </div>
        <div class="text_succses">
          <h2>Berhasil Mendaftar Training</h2>
        </div>

        <div class="date_proses">
          <p>19 Mei 2023, 12:56</p>
        </div>
        <h3 id="Detail">Detail</h3>
        <div class="p-x-20 p-y-16 bg-white">
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">Nama Program</div>
            <div class="f-regular f-16 f-c-black">Training Berbayar Online</div>
          </div>
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">Tanggal Training ke 1</div>
            <div class="f-regular f-16 f-c-black">4 Agustus 2023 11:00</div>
          </div>
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">Tanggal Training ke 2</div>
            <div class="f-regular f-16 f-c-black">8 Agustus 2023 07:00</div>
          </div>
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">Nomor Tagihan</div>
            <div class="f-regular f-16 f-c-black">SMT546786543456</div>
          </div>
        </div>
        <div class="separator-line-dot p-d-8"></div>

        <div class="p-x-20 p-y-16 bg-white">
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">Total Tagihan</div>
            <div class="f-regular f-16 f-c-black">Rp 500.000</div>
          </div>
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">Biaya Admin</div>
            <div class="f-regular f-16 f-c-black">Rp 200</div>
          </div>
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey">Promo</div>
            <div class="f-regular f-16 f-c-black">Rp 0</div>
          </div>
        </div>
        <div class="separator-line-dot p-d-8"></div>
        <div class="p-x-20 p-y-16 bg-white">
          <div class="d-flex-between-center p-d-8">
            <div class="f-regular f-16 f-c-midgrey" style="font-weight: bold">
              Total
            </div>
            <div class="f-regular f-16 f-c-black" style="font-weight: bold">
              Rp 500.200
            </div>
          </div>
        </div>
        <div class="btn_kembali p-x-20">
          <button
            type="button"
            class="btn btn-outline-primary btn-long"
            @click="kembali"
            style="width: 100%"
          >
            Kembali
          </button>
        </div>
        <div style="margin-top: 10px"></div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

export default {
  name: "informasiPembayaran_Success_TrainingOnline",
  components: {
    SOTitleBar: SOTitleBar,
    SOSlotBase: SOSlotBase,
    SOLoadingPage: SOLoadingPage,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    kembali() {
      this.$router.push({ name: "trainingWithTraining" });
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.logo_checklist {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.text_succses {
  align-self: stretch;
  width: 75%;
  margin: auto;
  margin-top: 8px;
}
.text_succses > h2 {
  text-align: center;
  font-family: Overpass;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.36px;
  color: #138132;
}

.date_proses {
  text-align: center;
  font-family: Overpass;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
  letter-spacing: -0.28px;
  color: #595959;
}
#Detail {
  font-family: Overpass;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
  margin-left: 20px;
  margin-top: 10px;
}

.btn_kembali {
  display: flex;
  justify-content: center;
  margin-top: 5%;
}

@media (min-width: 320px) and (max-width: 768px) {
  .btn_kembali {
    display: flex;
    justify-content: center;
    margin-top: 3%;
  }
}
</style>
